import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { resendEmailVerification } from '../apiCallsHelper/authapicalls';
import todoLogo from "../images/TodoMate-logo.png"
import LoadingOverlay from '../utils/LoadingOverlay';



const ResendAccountVerification = () => {

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);



  const handleVerifyEmailResent = () => {
    setIsLoading(true);
    resendEmailVerification(email).then(data => {
      if (data.error) {
        setIsLoading(false);
        setMessage(data.error);
      }
      else {
        setIsLoading(false);
        setMessage(data.message);
      }
    })
  }




  return (
    <>
      <Link className='mt-4 flex justify-center' to="/">
        <img src={todoLogo} className=' w-[80px] h-[80px]' alt="todo logo" />
      </Link>
      {isLoading && <LoadingOverlay />}
      <div className='w-[250px] h-[500px]    xs:w-[340px] xs:h-[500px]    sm:w-[470px] sm:h-[480px]     xl:w-[470px] xl:h-[480px]   container mt-[-40px] mb-4 mx-auto border-2 border-gray-300 rounded-md'>
        <div className='w-[400px] mx-auto mt-16 '>
          <div className='text-blue-500  mt-6 h-4 text-center'>
            {message ? message : ""}
          </div>
          <div className='text-md  xs:text-xl sm:text-xl md:text-2xl smLaptop:text-2xl lg:text-3xl xl:text-3xl   mt-6 text-center text-[#183e70] font-bold'>
            Resend Verification Email
          </div>
          <div className='mt-6 text-[#183e70]'>
            Please provide your the email address.
            A link will be sent to your inbox to verify your email, if an account exists for the email provided.
          </div>
          <div className='mt-4'>
            <label htmlFor="verifyEmail" className='font-semibold text-[#183e70]'>Email</label>
            <input value={email} onChange={(event) => setEmail(event.target.value)} type="email" id="verifyEmail" className="bg-gray-50 text-black  pl-2 pr-2 py-2 border border-gray-300  shadow-md  shadow-blue-100 focus:outline-blue-500 rounded w-full" />
          </div>
          <button onClick={handleVerifyEmailResent} className='bg-[#a6bffc] mt-10 py-2 w-full rounded-md hover:bg-[#6f8dd9] hover:text-white text-[#183e70]'>Send Email</button>
          <Link className='mt-4 text-xs text-blue-500 cursor-pointer float-right' to="/signin">
            Go back to login?
          </Link>
        </div>
      </div>
    </>
  )
}




export default ResendAccountVerification;